import { usePushLogic } from './usePushLogic.js';

/** Mounted once for the whole app: keeps this browser's notification sign-up current. */
export const PushSync = () => {
  usePushLogic();
  return null;
};
